import React from 'react';
import { Row, Col } from 'react-bootstrap';
import AboutBannerImg from '../assets/images/about-banner.png';

const AboutBanner = ({ section, imageUrl }) => {
  const title = section?.title || 'Your <span>trusted</span> home<br>for getting home';
  const description = section?.description ||
    'Jambobay is the housing super app — an ecosystem of products and services...';
  const subDescription = section?.sub_description || 'Jambobay has been helping people get homes.';

  return (
    <section className="about-banner-section">
      <Row>
        <Col lg={6} md={12} className='about-content-box align-self-center'>
          <div className="about-content">
            <h1
              className="about-title"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <div
              className="about-description"
              dangerouslySetInnerHTML={{ __html: description }}
            />
            <p className="about-subtitle">{subDescription}</p>
          </div>
        </Col>
        <Col lg={6} md={12}>
          <div className="about-image">
            <img
              src={imageUrl || AboutBannerImg}
              alt="Modern House"
              className="house-img"
            />
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default AboutBanner;